module.exports = __webpack_public_path__ + "img/copy-icon.c52ec28d.svg";